export default __webpack_public_path__ + "static/media/paperclip.528c8f25.svg";